import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import acl_45global from "/app/middleware/acl.global.ts";
import check_45menu_45access_45global from "/app/middleware/check-menu-access.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  acl_45global,
  check_45menu_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  "check-groups": () => import("/app/middleware/check-groups.ts")
}